import { render, staticRenderFns } from "./LessonNotification.vue?vue&type=template&id=400edefe&scoped=true&"
import script from "./LessonNotification.vue?vue&type=script&lang=js&"
export * from "./LessonNotification.vue?vue&type=script&lang=js&"
import style0 from "./LessonNotification.vue?vue&type=style&index=0&id=400edefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400edefe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
